<template>
  <div>
    <!--摄影订单  -->
    <baseBreadcrumb :page="$t('message.photographOrder')" :menu="$t('message.photographyServices')" />
    <div class="body">
      <!-- 搜索 -->
      <div class="search">
        <div class="item">
          <el-input v-model="datas.user_id" :placeholder="$t('message.userID')"></el-input>
        </div>
        <div class="item">
          <el-input v-model="datas.order_sn" :placeholder="$t('message.orderNumber')"></el-input>
        </div>
        <!-- 搜索 -->
        <el-button type="primary" @click="search">
          {{ $t('message.search') }}
        </el-button>
        <!-- 新建任务单 -->
        <el-button type="success" class="add" @click="addItem('')" v-if="isAuth(546)">
          {{ $t('message.createANewTaskOrder') }}
        </el-button>
      </div>
      <!-- 列表 -->
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
          <!-- NO -->
          <el-table-column align="center" label="NO" prop="rowNumber" width="100">
          </el-table-column>
          <!-- 客户信息 -->
          <el-table-column align="center" :label="$t('message.userInfo')" prop="id" width="200">
            <template slot-scope="scope">
              <p>ID:{{ scope.row.user_id }}</p>
              <p>{{ scope.row.user.realname }}</p>
              <attributeName :name="scope.row.client_attribute.name" />
            </template>
          </el-table-column>
          <!-- 对应人员 -->
          <el-table-column align="center" :label="$t('message.correspondingPersonnel')" prop="realname" width="200">
            <template slot-scope="scope">
              <div class="text-left">
                <!-- 业务员 -->
                <p>
                  {{ $t("message.salesman") }}：{{ scope.row.y_admin ? scope.row.y_admin.realname : '' }}
                </p>
                <!-- 配货员 -->
                <p>
                  {{ $t("message.distributionMember") }}：{{ scope.row.p_admin ? scope.row.p_admin.realname : '' }}
                </p>
                <!-- 采购员 -->
                <p>{{ $t("message.buyer") }}：{{ scope.row.g_admin ? scope.row.g_admin.realname : '' }}</p>
              </div>
            </template>
          </el-table-column>
          <!-- 订单号 -->
          <el-table-column align="center" :label="$t('message.orderNumber')">
            <template slot-scope="scope">
              <router-link :to="'/orderDetail?order_sn=' + scope.row.order_sn" target="_blank" class="a-link">
                {{ scope.row.order_sn }}</router-link>
            </template>
          </el-table-column>
          <!-- 业务摄影订单备注 -->
          <el-table-column align="center" :label="$t('message.businessRemarkographyOrderRemark')" prop="remark"
            width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.y_remark_pre" placeholder="请输入备注" type="textarea"
                @change="updateRemarkRemark(scope.row)"></el-input>
            </template>
          </el-table-column>
          <!-- 商品数 -->
          <el-table-column align="center" :label="$t('message.numberOfGoods')" prop="sum_goods_num" width="200">
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')" width="200">
            <template slot-scope="scope">
              <!-- 新建任务单 -->
              <el-button type="success" @click="addItem(scope.row.order_sn)" v-if="isAuth(546)" size="small">
                {{ $t('message.createANewTaskOrder') }}
              </el-button>
              <!-- 删除订单 -->
              <el-button type="success" @click="orderDelete(scope.row.order_sn)" v-if="isAuth(596)" size="small"
                class="dark">
                {{ $t('message.orderDelete') }}
              </el-button>

            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[100, 200, 500,]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 提交表单 -->
    <Form ref="Form" :itemData="itemData" />
  </div>
</template>
<script>
import Form from './components/form.vue';
export default {
  components: {
    Form
  },
  data() {
    return {
      datas: {
        user_id: '',
        order_sn: '',
        page: 1,
        pageSize: 100,
      },
      itemData: {},
      total: 0,
      tableData: []
    };
  },
  created() {
    this.orderList()
  },
  methods: {
    orderList() {
      this.$api.photo.orderList(this.datas).then(res => {
        this.tableData = res.data.data
        this.total = res.data.total
      })
    },
    search() {
      this.datas.page = 1
      this.orderList()
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.orderList()
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.orderList()
    },
    addItem(order_sn) {
      this.$refs.Form.dialogVisible = true
      this.$refs.Form.ruleForm.order_sn = order_sn
    },
    // 删除订单
    orderDelete(order_sn_set) {
      let datas = {
        order_sn_set: [order_sn_set],
      };
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.photo.deleteOrder(datas).then((res) => {
            this.$message.success(res.msg);
            this.orderList();
          });
        })
        .catch(() => { });
    },
    // 更新备注预设
    updateRemarkRemark(row) {
      let datas = {
        order_sn: row.order_sn,
        y_remark_pre: row.y_remark_pre,
      }
      this.$api.photo.updateRemarkRemark(datas).then(res => {
        this.$message.success(res.msg)

      })
    },

  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;
  margin-bottom: 24px;
  position: relative;

  .item {
    margin-right: 24px;
  }

  .add {
    position: absolute;
    top: 0;
    right: 0,
  }
}

.text-left {
  width: 100%;
  text-align: left;


}
</style>